import Vue from 'vue'
import VueRouter from 'vue-router'

const Index = () => import("../views/index/index")
const ContactUs = () => import("../views/contactUs/contactUs");
const CustomerCase = () => import("../views/customerCase/customerCase")
const EduIdeological = () => import("../views/creativeEducation/eduIdeological/eduIdeological")
const EduProfessional =() => import("../views/creativeEducation/eduProfessional/eduProfessional")
const EduSchoolBusiness=()=>import("../views/creativeEducation/eduSchoolBusiness/eduSchoolBusiness")
const ExaminationPlatform=()=>import("../views/creativeEducation/examinationPlatform/ExaminationPlatform")
const MetalProduction=()=>import("../views/solution/virtualSimulation/MetalProduction")
const IndustrialDigitalExperience=()=>import("../views/solution/virtualSimulation/IndustrialDigitalExperience")

const NewsList = () => import("../views/aboutXk/news/NewsList")
const NewsDetails = () =>import("../views/aboutXk/news/NewsDetails")
const RegularList = () => import("../views/aboutXk/notice/RegularList")
const TemporaryList = () => import("../views/aboutXk/notice/TemporaryList")
const NoticeDetails = () =>import("../views/aboutXk/notice/NoticeDetails")
const CoreCompetitiveness = () => import("../views/aboutXk/CoreCompetitiveness")
const CompanyProfile = () => import("../views/aboutXk/CompanyProfile")
const DevelopHistory = () => import("../views/aboutXk/DevelopHistory")
const CompanySituation = () => import("../views/aboutXk/CompanySituation")
const CarProducts = () => import("../views/solution/carProducts/CarProducts")
const NewEnergyVehicles = () => import("../views/solution/carProducts/NewEnergyVehicles")
const PraditionalCars = () => import("../views/solution/carProducts/PraditionalCars")
const Electromechanical = () => import("../views/solution/intelligenceProducts/Electromechanical")
const IndustrialInternet = () => import("../views/solution/intelligenceProducts/IndustrialInternet")
const IntelligentManufacturing = () => import("../views/solution/intelligenceProducts/IntelligentManufacturing")
const VirtualSimulation = () => import("../views/virtualsimulation/SteelSoftware")
const muyCloudPlatform = () => import("../views/solution/muyCloudPlatform")
const automotiveTechnology = () => import("../views/v2aiEducation/automotiveTechnology") // 汽车技术
const coreProduct = () => import("../views/v2aiEducation/coreProduct") // 核心产品
const v2CustomerCase = () => import("../views/v2aiEducation/v2customerCase") // 客户案例
const ferrousMetallurgy = () => import("../views/v2aiEducation/ferrousMetallurgy") // 黑色冶金
const nonFerrousMetallurgy = () => import("../views/v2aiEducation/nonFerrousMetallurgy") // 有色冶金
const fireProtection = () => import("../views/v2aiEducation/fireProtection") // 智慧消防



const ideologicalAndPolitical = () => import("../views/v2aiEducation/ideologicalAndPolitical") // 思政教育
const professionalQuality = () => import("../views/v2aiEducation/professionalQuality") // 职业素养



// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
   {
    name: '核心产品',
    path: '/coreProduct',
    component:coreProduct,
    meta: {
      title: '核心产品',
      headerShow:true,
    }
  },
   {
    name: '客户案例',
    path: '/v2customerCase',
    component:v2CustomerCase,
    meta: {
      title: '客户案例',
      headerShow:true,
    }
  },
  {
    name: '汽车技术',
    path: '/automotiveTechnology',
    component:automotiveTechnology,
    meta: {
      title: '汽车技术',
      headerShow:true,
    }
  },
   {
    name: '黑色冶金',
    path: '/ferrousMetallurgy',
    component:ferrousMetallurgy,
    meta: {
      title: '黑色冶金',
      headerShow:true,
    }
  },
  {
    name: '有色冶金',
    path: '/nonFerrousMetallurgy',
    component:nonFerrousMetallurgy,
    meta: {
      title: '有色冶金',
      headerShow:true,
    }
  },
  {
    name: '智慧消防',
    path: '/fireProtection',
    component:fireProtection,
    meta: {
      title: '智慧消防',
      headerShow:true,
    }
  },
  {
    name: '思政教育',
    path: '/ideologicalAndPolitical',
    component:ideologicalAndPolitical,
    meta: {
      title: '思政教育',
      headerShow:true,
    }
  },
  {
    name: '职业素养',
    path: '/professionalQuality',
    component:professionalQuality,
    meta: {
      title: '职业素养',
      headerShow:true,
    }
  },
  {
    name: '木鸢云平台',
    path: '/muyCloudPlatform',
    component:muyCloudPlatform,
    meta: {
      title: '木鸢云平台',
      headerShow:true,
      // footerShow: false, // 不显示页脚
      // tellUsShow: false  // 不显示tell-us组件
    }
  },

  {
    path: "",
    redirect: "/index",
  },
  {
    name: '首页',
    path: '/index',
    component: Index,
    meta: {
      title: '山东星科智能科技股份有限公司',
      headerShow:true,
    }
  },
  // {
  //   path: "",
  //   redirect: "/index",
  // },
  // {
  //   name: '墨斗智考平台',
  //   path: '/examinationPlatform',
  //   component:ExaminationPlatform,
  //   meta: {
  //     title: '墨斗智考平台',
  //     headerShow:true,
  //   }
  // },
  {
    path:'/core',
    component:CoreCompetitiveness,
    meta:{
      title:'核心竞争力',
      headerShow:true,
    }
  },
  {
    name:'公司简介',
    path:'/companyProfile',
    component:CompanyProfile,
    meta:{
      title:'公司简介',
      headerShow:true,
    }
  },

  {
    name: '发展历程',
    path: '/history',
    component:DevelopHistory,
    meta: {
      title: '发展历程',
      headerShow:true,
    },
  },
  {
    name:'news',
    path:'/news/newsList',
    component:NewsList,
    meta:{
      title:'新闻中心',
      headerShow:true,
    },
  },
  {
    name:'新闻中心',
    path:'/news/newsDetails',
    component:NewsDetails,
    meta:{
      title:'新闻中心',
      headerShow:true,
    }
  },

  {
    name: '公司概况',
    path: '/companyituation',
    component:CompanySituation,
    meta: {
      title: '公司概况',
      headerShow:true,
    }
  },
  {
    name:'temporaryList',
    path:'/notice/temporaryList',
    component:TemporaryList,
    meta:{
      title:'临时公告',
      headerShow:true,
    },
  },
  {
    name:'regularList',
    path:'/notice/regularList',
    component:RegularList,
    meta:{
      title:'定期公告',
      headerShow:true,
    },
  },
  {
    name:'noticeDetails',
    path:'/notice/noticeDetails',
    component:NoticeDetails,
    meta:{
      title:'公告详情',
      headerShow:true,
    }
  },

  {
    name: '智能网联汽车',
    path: '/carproducts',
    component:CarProducts,
    meta: {
      title: '智能网联汽车',
      headerShow:true,
    }
  },
  {
    name: '新能源汽车',
    path: '/newenergyvehicles',
    component:NewEnergyVehicles,
    meta: {
      title: '新能源汽车',
      headerShow:true,
    }
  },
  {
    name: '传统能源汽车',
    path: '/praditionalcars',
    component:PraditionalCars,
    meta: {
      title: '传统能源汽车',
      headerShow:true,
    }
  },


  {
    name: '机电产品',
    path: '/electromechanical',
    component:Electromechanical,
    meta: {
      title: '机电产品',
      headerShow:true,
    }
  },
  {
    name: '智能制造产品',
    path: '/intelligentmanufacturing',
    component:IntelligentManufacturing,
    meta: {
      title: '智能制造',
      headerShow:true,
    }
  },
  {
    name: '工业互联网',
    path: '/industrialInternet',
    component:IndustrialInternet,
    meta: {
      title: '工业互联网',
      headerShow:true,
    }
  },


  {
    name: '冶金生产仿真',
    path: '/metalProduction',
    component:MetalProduction,
    meta: {
      title: '冶金生产仿真',
      headerShow:true,
    }
  },
  {
    name: '工业数字体验馆',
    path: '/industrialDigitalExperience',
    component:IndustrialDigitalExperience,
    meta: {
      title: '工业数字体验馆',
      headerShow:true,
    }
  },
  {
    name: '行知学徒网',
    path: '/www.ixueto.com',
    meta: {
      title: '行知学徒网',
      headerShow:true,
    }
  },
  {
    name: '思政实训系统',
    path: '/eduIdeological',
    component:EduIdeological,

    meta: {
      title: '思政实训系统',
      headerShow:true,
    }
  },
  {
    name: '职业核心素养',
    path: '/eduProfessional',
    component:EduProfessional,
    meta: {
      title: '职业核心素养',
      headerShow:true,
    }
  },
  {
    name: '校企专业共建',
    path: '/eduSchoolBusiness',
    component:EduSchoolBusiness,
    meta: {
      title: '校企专业共建',
      headerShow:true,
    }
  },
  {
    name: '墨斗智考平台',
    path: '/examinationPlatform',
    component:ExaminationPlatform,
    meta: {
      title: '墨斗智考平台',
      headerShow:true,
    }
  },

  {
    name: '客户案例',
    path: '/customerCase',
    component: CustomerCase,
    meta: {
      title: '客户案例',
      active: 'customerCase',
      headerShow:true,
    },
  },
  {
    name: '联系我们',
    path: '/contactUs',
    component: ContactUs,
    meta: {
      title: '联系我们',
      active:'contactUs',
      headerShow:true,
    },
  },{
    name: '虚拟仿真实训系统',
    path: '/steelsoftware',
    component:VirtualSimulation,
    meta: {
      title: '虚拟仿真实训系统'
    }
  },
];
const router = new VueRouter({
  routes,
  mode: "hash"
});
//以下代码解决路由地址重复点击的报错问题
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

router.beforeEach(function (to, from, next) {
  if (to.meta.title) {//如果设置标题，拦截后设置标题
    document.title = to.meta.title
  };
  router.app.$options.store.commit('updateCurrentPath',to.path);
  next();
})
// 3.导出router
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js